<div *transloco="let t; prefix: 'breakdown-table'" class="breakdown-table-details__container">
  <div class="breakdown-table-details__header"></div>
  <div class="breakdown-table-details__table">
    <app-driver-table
      [drivers]="drivers()"
      [predictiveOptions]="predictiveOptions()"
      [isReadOnly]="isReadOnly()"
      [isDashboardLocked]="isDashboardLocked()"
      [comparison]="comparison()"
      (simulate)="onSimulateDriver($event)"
      (reset)="onResetDriver($event)"
      (smartSummary)="onSmartSummaryDriver($event)"
      (hover)="onHoverDriver($event)"
    >
    </app-driver-table>
  </div>
</div>
